import { render, staticRenderFns } from "./CollectionCustomer.vue?vue&type=template&id=aaae1674&scoped=true"
import script from "./CollectionCustomer.vue?vue&type=script&lang=js"
export * from "./CollectionCustomer.vue?vue&type=script&lang=js"
import style0 from "./CollectionCustomer.vue?vue&type=style&index=0&id=aaae1674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaae1674",
  null
  
)

export default component.exports